export default __webpack_public_path__ + "static/media/PSCI.b5bc1532.png";